import angular from 'angular';
import moment from 'moment';
angular.module('cxTable').directive('cxTable', [
  '$http',
  '$timeout',
  'resourceFactorySvc',
  'flySvc',
  '$q',
  function($http, $timeout, resourceFactorySvc, flySvc, $q) {
    return {
      restrict: 'A',
      priority: 51,
      compile: function() {
        return {
          pre: function(scope, element, attrs, ctrl) {
            var name = attrs.name || 'table';
            var bindTo = scope.$eval(attrs.bindTo) || scope.$parent;
            //Put the contoller on the parent scope
            bindTo[name] = ctrl;

            var cxTable = scope.$eval(attrs.cxTable) || attrs.cxTable;
            if (!cxTable) return;
            if (angular.isArray(cxTable)) {
              //If the cxTable attr is an array, add all items in array to table rows
              scope.$watchCollection(attrs.cxTable, function(newValue) {
                ctrl.setRows(newValue);
              });
              return;
            }
            //Init sort column if provided
            if (cxTable.sortBy) {
              ctrl.initSort(cxTable.sortBy, cxTable.sortDesc);
            }
            if (cxTable.initParams) {
              ctrl.initializeParams(cxTable.initParams);
            }

            //If the cxTable attr is an object with property source, the table is a scroll table
            if (cxTable.source) {
              //Required property: source
              //There are other required properties, but it depends on the source (see below).
              //Optional property: take (number of items per paging request, default 50)

              //Helper functions:
              var handlePromise = function(params) {
                //Creates a function to handle the promise result
                //Store page nr in variable for reference
                var page = params.page;

                return function(data) {
                  //Check if the referenced page nr is the same as the table page nr
                  if (page !== ctrl.tableInfo.page) return null; //If it's not the same, abort appending data. There probably was a reload at the same moment.
                  //If there is a property data which is an array, that's probably our data. (See $http response)
                  if (data && angular.isArray(data.data)) return data.data;
                  return data;
                };
              };

              var handleError = function(error) {
                //Show fly-in when there's an error
                if (error && error.data) flySvc.error(error.data.code, error.data.parameters);
                return error;
              };

              //Scroll table source, allowed values: 'URL', 'R', 'F'
              cxTable.source = cxTable.source.toUpperCase();
              if (cxTable.source === 'URL') {
                //Http get with url
                //Extra required param: url
                if (cxTable.url)
                  ctrl.enablePaging(
                    function(params) {
                      return $http
                        .get(cxTable.url, {
                          params: params,
                        })
                        .then(handlePromise(params), handleError);
                    },
                    cxTable.take,
                    cxTable.noResultMsg,
                  );
              } else if (cxTable.source === 'R') {
                //Resource factory
                //Extra required param: type (the type of the resource in the resource factory)
                //Optional param: action (the action that's called on the resource, default 'query')
                if (cxTable.type) {
                  cxTable.action = cxTable.action || 'query';
                  var resource = resourceFactorySvc.get(cxTable.type);
                  if (resource !== null)
                    ctrl.enablePaging(
                      function(params) {
                        return resource[cxTable.action](params, handlePromise(params), handleError)
                          .$promise;
                      },
                      cxTable.take,
                      cxTable.noResultMsg,
                    );
                }
              } else if (cxTable.source === 'F') {
                //Function with promise
                //Extra required param: func (this function is called with a params argument, it must return a promise which returns an array)
                if (typeof cxTable.func == 'function')
                  ctrl.enablePaging(
                    function(params) {
                      return $q.when(cxTable.func(params)).then(handlePromise(params), handleError);
                    },
                    cxTable.take,
                    cxTable.noResultMsg,
                  );
              } else console.warn('ScrollTable: Unknown source');
            }
          },
          post: function() {},
        };
      },
      scope: true,
      controllerAs: 'table',
      controller: function() {
        var table = this;

        table.rows = null;
        //table.columns = [];
        table.tableInfo = {
          sortBy: null,
          sortDesc: false,
          search: {}, //Should be an object with properties
          filters: {}, //Should be an object with properties
        };
        //Default no paging
        table.paging = false;

        table.filterTable = function(row) {
          //Filtering in backend
          if (table.paging) return true;

          var filters = table.tableInfo.filters;
          if (!filters || !row) return true;

          //Loop over every property in the table filter
          for (var prop in filters) {
            if (filters.hasOwnProperty(prop) && typeof row[prop] != 'undefined') {
              var filter = filters[prop];
              if (angular.isFunction(filter)) {
                //Filter is a function so call the filter function with the property value
                if (!filter(row[prop])) return false;
              } else if (filter.items && angular.isArray(filter.items)) {
                //The property filter has an array
                //Check if the property of the row matches one of the filters.
                var found = false;
                for (var i = 0; i < filter.items.length && !found; i++)
                  if (row[prop] === filter.items[i]) found = true; //Filter matches property
                if (!found) return false; //Not found
              } else {
                //Number & Date filters
                if (typeof filter.lesser !== 'undefined' && typeof filter.greater !== 'undefined') {
                  var value = row[prop];
                  if (typeof value === 'string' && !isNaN(value)) value = parseFloat(value);
                  if (typeof value === 'string' && Date.parse(value) !== null)
                    value = new moment(value).toDate();

                  if (filter.lesser !== null && value > filter.lesser) return false;
                  if (filter.greater !== null && value < filter.greater) return false;
                }
              }
            }
          }
          return true;
        };

        //table.addColumn = function (column) {
        //    if (!column) return;
        //    table.columns.push(column);
        //};

        //Remove all table rows
        table.clearRows = function() {
          if (!table.rows) return;
          table.rows.clear();
        };

        //Append rows to the end of the table
        table.appendRows = function(rows) {
          if (!rows || !angular.isArray(rows)) return;
          if (!table.rows) table.rows = [];
          for (var i = 0; i < rows.length; i++) table.rows.push(rows[i]);
        };

        //Replace all rows
        table.setRows = function(rows, stopPaging) {
          if (!rows || !angular.isArray(rows)) return;
          table.clearRows();
          table.appendRows(rows);
          if (stopPaging) {
            table.retrieving = true;
          }
        };

        //Sort on a column
        table.sort = function(column, sortDesc = undefined) {
          table.tableInfo.sortDesc = angular.equals(column, table.tableInfo.sortBy)
            ? !table.tableInfo.sortDesc
            : false;
          if (typeof sortDesc !== 'undefined') table.tableInfo.sortDesc = !!sortDesc;
          table.tableInfo.sortBy = column;

          if (table.paging && table.reload) table.reload();
        };

        //Replace a property filter
        table.setFilter = function(prop, filter) {
          if (!prop) return;
          table.tableInfo.filters[prop] = filter;

          if (table.paging && table.reload) table.reload();
        };

        //Clear property filter for 1 column or all
        table.clearFilter = function(prop) {
          if (prop) {
            delete table.tableInfo.filters[prop];
          } else {
            table.tableInfo.filters = {};
          }

          if (table.paging && table.reload) table.reload();
        };

        //Replace search filter on a column
        table.setSearch = function(prop, search) {
          if (!prop) return;
          table.tableInfo.search[prop] = search;

          if (table.paging && table.reload) table.reload();
        };

        //Clear search filter for 1 column or all
        table.clearSearch = function(prop) {
          if (prop) {
            delete table.tableInfo.search[prop];
          } else {
            table.tableInfo.search = {};
          }

          if (table.paging && table.reload) table.reload();
        };

        table.initSort = function(sortBy, sortDesc) {
          table.tableInfo.sortDesc = !!sortDesc;
          table.tableInfo.sortBy = sortBy;
        };

        //Initialize paging
        table.enablePaging = function(retrieve, take, noResultMsg) {
          if (typeof retrieve !== 'function') return;
          if (table.paging === true) return;
          table.retrieve = retrieve;
          table.tableInfo.page = -1; //Init page nr to -1 so page 0 is loaded next time
          table.tableInfo.take = take || 50; //Nr of items per paging request
          table.retrieving = false; //Only 1 page can be retrieved a time
          table.noResultMsg = noResultMsg;

          //Create getNextPage function
          table.getNextPage = function() {
            if (table.retrieving && table.tableInfo.page !== -1) {
              return; //Block next page request if there is already a request in progress. Except if a reload is requested (page nr -1)
            }
            //Increment page nr
            table.tableInfo.page += 1;
            //Create params object
            var params = table.currentParams();
            //Set retrieving to true
            table.retrieving = true;

            //Retrieve
            table.retrieve(params).then(function(rows) {
              table.appendRows(rows);
              if (table.tableInfo.page === 0) table.showSpinner = false;

              //Render new lines first before setting retrieving prop
              $timeout(function() {
                //Stop retrieving if the result isn't an array or if the nr of result is lower than the "items per paging request".
                table.retrieving = !angular.isArray(rows) || rows.length !== table.tableInfo.take;
              }, 0);

              if (rows && rows.length === 0 && params.page === 0 && table.noResultMsg)
                flySvc.message('msgPagingNoResults');
            });
          };

          table.paging = true;
          table.reloading = null; //Placeholder to store the reload timeout promise
          table.reload = function() {
            //Set page nr to -1 to load page 0 next time
            table.tableInfo.page = -1;
            //Remove all rows from table
            table.clearRows();

            //Because many actions trigger a reload, reloads are grouped together.
            //If there's a previous reloading request, cancel it.
            if (table.reloading !== null) $timeout.cancel(table.reloading);
            //Call getNextPage after timeout, set cancel promise reference
            table.reloading = $timeout(table.getNextPage, 100);
            table.reloading.then(function() {
              table.reloading = null;
            });
          };
        };

        table.currentParams = function() {
          return {
            take: table.tableInfo.take,
            page: table.tableInfo.page,
            sort: table.tableInfo.sortBy,
            desc: table.tableInfo.sortDesc,
            search: table.tableInfo.search,
            filter: table.tableInfo.filters,
          };
        };

        table.initializeParams = function(params) {
          if (!params) return;

          table.tableInfo = {
            ...table.tableInfo,
            sortBy: params.sort ?? table.tableInfo.sortBy ?? null,
            sortDesc: params.desc ?? table.tableInfo.sortDesc ?? true,
            search: params.search || {},
            filters: params.filter || {}, //Should be an object with properties
          };
        };
      },
    };
  },
]);
